var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Account',{attrs:{"title":"My activity"}},[_c('AccountHistoryTable',{attrs:{"depth":"user"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }